<template>
  <div class="fmhind-radio-button">
    <div
      v-for="(option, index) in options"
      class="fmhind-radio-button__option"
      :key="index"
      @click="selectOption(index)"
    >
      <span
        class="fmhind-radio-button__checkbox"
        :class="{
          'fmhind-radio-button__checkbox--ticked': index === selectedOption
        }"
      />
      <span class="fmhind-radio-button__option-text">
        {{ option.includes('ChartText') ? $t(option) : option }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RadioButtons',
  props: {
    options: {
      type: Array,
      required: true,
      validator: prop => prop.every(item => typeof item === 'string')
    },
    value: {
      type: String,
      required: false
    }
  },
  data() {
    return {
      selectedOption: null
    };
  },
  created() {
    this.updateSelectedOption();
  },
  methods: {
    selectOption(index) {
      this.selectedOption = index;
      this.$emit('input', this.options[index]);
    },
    updateSelectedOption() {
      const index = this.options.findIndex(o => o === this.value);
      if (index > -1) {
        this.selectedOption = index;
      } else {
        this.selectedOption = null;
      }
    }
  }
};
</script>

<style lang="scss">
$radio-button-size: $unit * 1.2;
.fmhind-radio-button {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.fmhind-radio-button__option {
  display: flex;
  align-items: center;
  margin-right: $radio-button-size;
  margin-bottom: $unit;
  cursor: pointer;
}

.fmhind-radio-button__option-text {
  @extend %text-sm;
}

.fmhind-radio-button__checkbox {
  width: $radio-button-size;
  height: $radio-button-size;
  border-radius: 100%;
  border: 1px solid black;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: $radio-button-size * 0.35;

  &--ticked {
    &:before {
      content: '';
      visibility: visible;
      width: $radio-button-size * 0.8;
      height: $radio-button-size * 0.8;
      background: $color-primary;
      border: none;
      border-radius: 100%;
      box-sizing: border-box;
      position: relative;
      display: block;
    }
  }
}
</style>
